import React, { useContext, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
import Col from '../../UIcomponent/Column'
import Text from '../../UIcomponent/Text'
import empty from '../../Assets/icon/empty.svg'
import StyledButton from '../../UIcomponent/Button'

const Container = styled(Col)`
width : 100%;
height : 100%;
flex-direction : column;
justify-content : center;
align-items : center;
display : ${props => props.visible !== true && 'none'};
z-index : 120;
`
const Icon = styled(Col)`
width : 80px;
height : 80px;
background-size: contain;
font-size : ${props => props.fontSize};
margin:0 auto;
padding: 0px;
background-image : ${props => `url(${props.source})`};

`
const Description = styled(Col)`
margin : 0 auto;
padding : 0px;
margin-top:15px;

`
const NoItemFound = (props) => {
    const theme = useContext(ThemeContext)
    const { actionHandler, actionTitle, visible, source, desc, noAction } = props
    return (
        <Container
            visible={visible}
        >
            <Icon
                source={source || empty}
            ></Icon>
            <Description
                fontSize={theme.fontSizeLg}
            >
                {desc || 'موردی یافت نشد'}
            </Description>
            <StyledButton
                style={{
                    display: noAction && 'none',
                    marginTop: '15px',
                    cursor: 'pointer'
                }}
                default
                notHoverable
                onClick={actionHandler}
            >
                {actionTitle || 'بازگشت'}
            </StyledButton>
        </Container>
    )

}
export default NoItemFound